export const LOGIN_FETCH = 'LOGIN_FETCH'
export const LOGIN_FETCH_SUCCESS = 'LOGIN_FETCH_SUCCESS'
export const LOGIN_FETCH_FAILED = 'LOGIN_FETCH_FAILED'

export const AUTOLOGIN_FETCH = 'AUTOLOGIN_FETCH'
export const AUTOLOGIN_FETCH_SUCCESS = 'AUTOLOGIN_FETCH_SUCCESS'
export const AUTOLOGIN_FETCH_FAILED = 'AUTOLOGIN_FETCH_FAILED'

export const LOGOUT_FETCH = 'LOGOUT_FETCH'
export const LOGOUT_FETCH_SUCCESS = 'LOGOUT_FETCH_SUCCESS'
export const LOGOUT_FETCH_FAILED = 'LOGOUT_FETCH_FAILED'

export const INSTANCES_FETCH = 'INSTANCES_FETCH'
export const INSTANCES_FETCH_SUCCESS = 'INSTANCES_FETCH_SUCCESS'
export const INSTANCES_FETCH_FAILED = 'INSTANCES_FETCH_FAILED'

export const REGISTRATION_FETCH = 'REGISTRATION_FETCH'
export const REGISTRATION_FETCH_SUCCESS = 'REGISTRATION_FETCH_SUCCESS'
export const REGISTRATION_FETCH_FAILED = 'REGISTRATION_FETCH_FAILED'

export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_DATA_SUCCESS = 'SET_USER_DATA_SUCCESS'
export const SET_USER_DATA_FAILED = 'SET_USER_DATA_FAILED'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED'

export const GET_CALL_URL = 'GET_CALL_URL'
export const GET_CALL_URL_SUCCESS = 'GET_CALL_URL_SUCCESS'
export const GET_CALL_URL_FAILED = 'GET_CALL_URL_FAILED'

export const SET_CALL_URL = 'SET_CALL_URL'
export const SET_CALL_URL_SUCCESS = 'SET_CALL_URL_SUCCESS'
export const SET_CALL_URL_FAILED = 'SET_CALL_URL_FAILED'
